import omitBy from 'lodash/omitBy'
import isNil from 'lodash/isNil'
import Cookies from 'js-cookie'
import URL from 'url'
import config from '../config'

const callApi = async ({ fullURL, url, method, query, body, headers }) => {
  if (method === 'post' || method === 'POST' || body) {
    const vip = localStorage.getItem('thereisnospoon')
    body = vip ? { ...body, vip } : body
  }
  const response = await fetch(
    `${fullURL || `${config.apiHost}${encodeURI(url)}`}${URL.format({
      query,
    })}`,
    omitBy(
      {
        method: method || (body ? 'POST' : 'GET'),
        headers: headers
          ? headers
          : omitBy(
              {
                'Content-Type': 'application/json; charset=utf-8',
                accessToken: Cookies.get('accessToken'),
              },
              isNil,
            ),
        body: body ? JSON.stringify(body) : undefined,
      },
      isNil,
    ),
  )

  if (response.ok) {
    const json = await response.json()
    return Promise.resolve(json)
  } else {
    const json = await response.json()
    return Promise.reject({ statusCode: response.status, reason: json })
  }
}

export default callApi
